import { Button, TextField, Typography } from "@mui/material"
import { History } from "history"
import queryStringify from "querystringify"
import { Dispatch, SetStateAction, useState } from "react"
import Helmet from "react-helmet"
import { TFunction, useTranslation } from "react-i18next"
import { withRouter } from "react-router-dom"
import logo from "./../../assets/logo.svg"
import { Props, QueryString } from "./NoHost.types"

const createRoom = async (
  userName: string,
  setUserNameError: Dispatch<SetStateAction<string | null>>,
  setLoading: Dispatch<SetStateAction<boolean>>,
  t: TFunction<"translation">,
  history: History
) => {
  setLoading(true)

  const experienceId = (
    queryStringify.parse(window.location.search) as QueryString
  ).experience

  const errorHandler = () => setUserNameError(t`Error`)

  fetch(
    `${process.env.REACT_APP_SERVER_URL}/experiences/${experienceId}/rooms?noHost=true&company=${userName} (no host)`,
    {
      method: "POST",
    }
  )
    .then((response) =>
      response.json().then(({ roomCode }: { roomCode: number }) =>
        fetch(
          `${process.env.REACT_APP_SERVER_URL}/room/join?roomCode=${roomCode
            .toString()
            .replace("-", "")}&name=${userName}`,
          {
            method: "POST",
          }
        )
          .then((response) =>
            response
              .json()
              .then(({ participantId }: { participantId: string }) => {
                if (
                  localStorage.getItem("idRoomPairs") &&
                  JSON.parse(localStorage.getItem("idRoomPairs")!)
                ) {
                  localStorage.setItem(
                    "idRoomPairs",
                    JSON.stringify([
                      ...JSON.parse(
                        localStorage.getItem("idRoomPairs")!
                      ).filter(
                        ({ code: codeToRemove }: { code: number }) =>
                          roomCode !== codeToRemove
                      ),
                      { code: roomCode.toString(), participantId },
                    ])
                  )
                } else {
                  localStorage.setItem(
                    "idRoomPairs",
                    JSON.stringify([
                      { code: roomCode.toString(), participantId },
                    ])
                  )
                }

                history.push(`?experience=${experienceId}&room=${roomCode}`)
              })
          )
          .catch(errorHandler)
          .finally(() => setLoading(false))
      )
    )
    .catch(errorHandler)
    .finally(() => setLoading(false))
}

const NoHost = withRouter(({ history }: Props) => {
  const { t } = useTranslation()

  const [userName, setUserName] = useState<string>("")
  const [userNameError, setUserNameError] = useState<string | null>(null)
  const [userNameEmpty, setUserNameEmpty] = useState<boolean>(false)

  const [loading, setLoading] = useState<boolean>(false)

  const isCreateButtonDisabled = !userName

  return (
    <>
      <Helmet>
        <title>Lapwing - {t`Create room`}</title>
      </Helmet>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "fixed",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          backgroundColor: "#E6E2B1",
        }}
      >
        <div
          style={{
            margin: "auto",
            maxHeight: "100%",
            overflow: "auto",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#E6E2B1",
              textAlign: "center",
              padding: "32px 0 16px 0",
            }}
            className="notSelectable"
          >
            <img alt="" src={logo} style={{ marginBottom: "48px" }} />
            <Typography
              variant="h4"
              style={{
                fontSize: "30px",
                fontWeight: 600,
                margin: "0 32px 8px 32px",
                color: "#181818",
              }}
            >
              {t`Welcome to the Lapwing app`}
            </Typography>
            <Typography
              variant="h6"
              style={{
                fontWeight: 300,
                margin: "0 32px",
                color: "#181818",
              }}
            >{t`Create a room to start your experience`}</Typography>
            <TextField
              label={t`Your name`}
              variant="outlined"
              style={{
                marginTop: "48px",
                width: "256px",
                textTransform: "none",
              }}
              onChange={(event) => {
                setUserName(event.target.value)
                setUserNameEmpty(event.target.value.replace(/\s/g, "") === "")
              }}
              onKeyPress={(event) => {
                if (event.key === "Enter" && !isCreateButtonDisabled) {
                  createRoom(userName, setUserNameError, setLoading, t, history)
                }
              }}
              helperText={
                userNameEmpty ? t`This field is required` : userNameError || " "
              }
            />
            <Button
              variant="outlined"
              style={{
                marginTop: "16px",
                width: "256px",
              }}
              size="large"
              disabled={isCreateButtonDisabled || loading}
              onClick={() =>
                createRoom(userName, setUserNameError, setLoading, t, history)
              }
            >{t`Create room`}</Button>
          </div>
        </div>
      </div>
    </>
  )
})

export default NoHost
